/* eslint-disable jira/naming/disallow-filenames */
/** @jsx jsx */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { css, jsx } from '@compiled/react';
import NewBoardIllustration from '@jira/illustrations__illustrations/src/ui/adg4/jira/spots/software/components/bug-and-task-cards-in-a-column/index.tsx';
import { useFormState } from '@atlaskit/form/use-form-state';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import type { BoardCreateFormValues } from './BoardCreateFormValues.types.tsx';

const illustrationPlaceHolderHeader = defineMessage({
	id: 'software-board-create.modal.illustration.illustration-place-holder-header',
	defaultMessage: 'New board',
	description: 'Appears above an illustration of a new board in the board creation modal',
});

const illustrationAltText = defineMessage({
	id: 'software-board-create.modal.illustration.illustration-alt-text',
	defaultMessage: 'Bug and task cards in a board column',
	description: 'Alt text for an illustration of a new board in the board creation modal',
});

export const ModalIllustration = (): JSX.Element => {
	const state = useFormState<BoardCreateFormValues>();
	const { formatMessage } = useIntl();
	return (
		<Stack>
			{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
			<h5 css={modalIllustrationHeaderStyles}>
				{state?.values.boardName?.trim() || formatMessage(illustrationPlaceHolderHeader)}
			</h5>
			<Stack alignBlock="center">
				<NewBoardIllustration alt={formatMessage(illustrationAltText)} height="334px" />
			</Stack>
		</Stack>
	);
};

const modalIllustrationHeaderStyles = css({
	font: token('font.heading.small'),
	fontWeight: token('font.weight.semibold'),
	color: token('color.text.subtle'),
	marginLeft: `calc(${token('space.800')} - ${token('space.150')})`,
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	maxWidth: '240px',
});
